import React from 'react';
import { motion } from 'framer-motion';
import BrandIcon from './BrandIcon';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
  showText?: boolean;
  variant?: 'default' | 'white';
  className?: string;
  animate?: boolean;
  isKids?: boolean;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 'md',
  showText = true,
  variant = 'default',
  className = '',
  animate = true,
  isKids = false,
}) => {
  const sizeMap = {
    sm: { icon: 24, text: 'text-xl' },
    md: { icon: 32, text: 'text-2xl' },
    lg: { icon: 48, text: 'text-4xl' },
    xl: { icon: 64, text: 'text-5xl' },
    '2xl': { icon: 80, text: 'text-6xl' },
    '3xl': { icon: 100, text: 'text-7xl' },
    '4xl': { icon: 120, text: 'text-8xl' }
  };

  const currentSize = sizeMap[size];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <BrandIcon 
        size={currentSize.icon} 
        variant={variant === 'white' ? 'white' : 'default'} 
        animate={animate} 
        isKids={isKids}
      />
      
      {showText && (
        <motion.span
          className={`font-display font-semibold tracking-tight ${currentSize.text} ${
            variant === 'white' ? 'text-white' : 'text-[var(--text-primary)]'
          }`}
          initial={animate ? { opacity: 0, x: -10 } : false}
          animate={animate ? { opacity: 1, x: 0 } : false}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          Novari{isKids && <span className="text-emerald-500 ml-1.5">Kids</span>}
        </motion.span>
      )}
    </div>
  );
};

export default BrandLogo;
